import { render, staticRenderFns, recyclableRender, components } from "./u-picker.vue?vue&type=template&id=a1c9e37c&scoped=true&"
var renderjs
import script from "./u-picker.vue?vue&type=script&lang=js&"
export * from "./u-picker.vue?vue&type=script&lang=js&"
import style0 from "./u-picker.vue?vue&type=style&index=0&id=a1c9e37c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!E:\\前端软件\\HBuilderX.3.2.12.20211029\\HBuilderX\\plugins\\uniapp-cli\\node_modules\\@dcloudio\\vue-cli-plugin-uni\\packages\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1c9e37c",
  null,
  false,
  components,
  renderjs
)

export default component.exports